/**
 * The `device.benchmark` payload (docs/telemetry/EVENTS.md). Pure, so the row's
 * shape is pinned by a test rather than by whatever the manager happens to pass.
 */
import type { BenchmarkResult } from "./benchmarkScore";
import type { DeviceMetrics } from "./deviceCapability";

export interface BenchmarkEnvironment {
  /** `reference.version`, or null when the black-frame fallback ran. */
  referenceVersion: number | null;
  backend: string | null;
  float32Enabled: boolean | null;
  forcedF16: boolean;
}

export function benchmarkEventData(
  result: BenchmarkResult,
  metrics: DeviceMetrics,
  env: BenchmarkEnvironment
): Record<string, unknown> {
  return {
    benchmarkVersion: env.referenceVersion,
    verdict: result.verdict,
    unknownReason: result.unknownReason,
    framesUsed: result.framesUsed,
    cyclesCompleted: result.cyclesCompleted,
    cycleMedianMs: metrics.cycleMedianMs,
    cycleMaxMs: metrics.cycleMaxMs,
    deviceClass: metrics.deviceClass,
    deviceClassSource: metrics.source,
    gatedDevMaxRatio: result.gatedDevMaxRatio,
    gatedDevMedianRatio: result.gatedDevMedianRatio,
    confidenceRatioMin: result.confidenceRatioMin,
    confidenceRatioMedian: result.confidenceRatioMedian,
    repeatJitterMaxRatio: result.repeatJitterMaxRatio,
    personFoundRatio: result.personFoundRatio,
    personBoxIoUMin: result.personBoxIoUMin,
    backend: env.backend,
    float32Enabled: env.float32Enabled,
    forcedF16: env.forcedF16,
  };
}
